import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  h4.loading-title {
    font-size: 2rem;
    font-family: Arial, Helvetica, sans-serif;
  }
`
